// extracted by mini-css-extract-plugin
export default {"buttonContinue":"Activation_buttonContinue__7fCap","btn":"Activation_btn__-6HAU"};